import React from 'react';
import {
  Typography,
  Box,
  CircularProgress as CircularProgressBase,
} from '@mui/material';

import { useStyles } from './styles';

const CircularProgress = ({ value = null, dataTestId }: { value?: number | null, dataTestId?: string }) => {
  const classes = useStyles();

  if (value === null) {
    return (
      <Box sx={classes.root}>
        <CircularProgressBase thickness={2} sx={classes.progress} />
      </Box>
    );
  }

  return (
    <Box sx={classes.root}>
      <CircularProgressBase
        variant="determinate"
        value={value}
        thickness={2}
        sx={classes.progress}
      />
      <Box sx={classes.content}>
        <Typography
          variant="caption"
          component="div"
          sx={classes.indicator}
          data-testid={dataTestId}
        >{`${Math.round(value)}%`}</Typography>
      </Box>
    </Box>
  );
};

export default CircularProgress;
